export default __webpack_public_path__ + "static/media/tour-e-agency-mobile-one.d0e7a8d1.png";